import { render } from "./paymentSuccessful.vue?vue&type=template&id=e29f594a&scoped=true"
import script from "./paymentSuccessful.vue?vue&type=script&lang=js"
export * from "./paymentSuccessful.vue?vue&type=script&lang=js"

import "./paymentSuccessful.vue?vue&type=style&index=0&id=e29f594a&lang=scss&scoped=true"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e29f594a"]])

export default __exports__